import React, { useState } from "react";
import { KTSVG } from "../../../helpers";

type Props = {
  className: string;
  innerPadding?: string;
};

const StepContent16: React.FC<Props> = ({ className, innerPadding = "" }) => {
  const [category, setCategory] = useState("1");
  const [option, setOption] = useState("1");
  const [fleet, setFleet] = useState("1");
  return (

      <div className={`card ${className}`}>
        {/* begin::Body */}
        <div className={`card-body ${innerPadding}`}>
          {/* begin::Title */}
          <div className="mb-10">
            <h3 className="fw-bold text-dark mb-2 fs-3">Define pricing framework</h3>
            <span className="fs-7 text-muted">
             Read each section and then fill in your answers at the bottom.
            </span>
          </div>
          {/* end::Title */}

          {/* begin::Section */}
          <div className="mb-10">
            <div className="accordion" id="kt_accordion_1">
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_1">
                  <button
                    className="accordion-button fs-7 fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_1"
                    aria-expanded="true"
                    aria-controls="kt_accordion_1_body_1"
                  >
                    Define pricing framework
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_1"
                  className="accordion-collapse collapse show"
                  aria-labelledby="kt_accordion_1_header_1"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                  In this step you will use your Quantified Value Proposition and business model to determine an appropriate first-pass framework for pricing your product. Now that you have settled on a business model, it is time to start coming up with a pricing strategy. Fine-tuning the strategy can have a huge impact on your earnings.

Pricing is primarily about determining how much value your customer gets from your product, and capturing a fraction of that value back for your business. Costs are irrelevant to determining your pricing structure. You will be able to charge a higher price to early customers as opposed to later customers, but be flexible in offering special, one-time-only discounts to select early testers and lighthouse customers, as they will be far more beneficial to your product’s success than the average early customer.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_2">
                  <button
                    className="accordion-button fs-7 fw-bold collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_2"
                    aria-expanded="false"
                    aria-controls="kt_accordion_1_body_2"
                  >
                    Basic pricing concepts
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_2"
                  className="accordion-collapse collapse show"
                  aria-labelledby="kt_accordion_1_header_2"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                  The pricing framework is extremely important in influencing your profitability, so it is important you price your product correctly. This is your attempt to strike a balance between attracting as much revenue as possible and attracting as many customers as possible.

Determine how much value your customer receives from your product (using the Quantified Value Proposition), and charge some fraction of that—20% is usually a good starting point, but the percentage depends on the business model. Do NOT determine price based on costs!
Use the DMU and the process to acquire a paying customer to identify key price points. They provide invaluable information about how your customer’s budget works. Knowing an individual’s purchasing authority limits can help reduce friction in the sales process.
Understand, from the customer’s perspective, the alternative products available, and how much the customer would pay for each, including the customer’s status quo. Carefully research what other alternatives would achieve similar benefits for the customer, what the prices of those alternatives are, and how much better your solution is.
Understand how and why different types of customers will pay different amounts, depending on how early or late they are buying relative to other customers. Consider each of the five waves of customers described by Geoffrey Moore in Crossing the Chasm: technological enthusiasts, early adopters, early majority, late majority and laggards.
Consider flexible pricing for early testers and “lighthouse customers”. These customers may help you create case studies or do on-site seminars where you can promote your product, or otherwise be strong references in the market.
Consider the fact it’s always easier to drop the price than to raise it. It is best to price high and offer discounts initially, rather than price too low and find you need to raise the price later.
                  </div>
                </div>
              </div>

            </div>
          </div>
          {/* end::Section */}

        </div>
        {/* end: Card Body */}
      </div>

  );
};

export { StepContent16 };
